/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Suggestions_Anchor_LostInputs */



/**
* | output |
* | --- |
* | "This suggestion no longer fits the document — the text it referred to has changed. Ask the AI to look at the document again." |
*
* @param {Suggestions_Anchor_LostInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const suggestions_anchor_lost = /** @type {((inputs?: Suggestions_Anchor_LostInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Suggestions_Anchor_LostInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Vorschlag passt nicht mehr zum Dokument – der Text, auf den er sich bezog, hat sich geändert. Bitte die KI, das Dokument erneut anzusehen.")
	return /** @type {LocalizedString} */ ("This suggestion no longer fits the document — the text it referred to has changed. Ask the AI to look at the document again.")
});